function mboxScript(isProd, env) {
  try {
    let profileName = spaParams?.siteParams?.bactmSiteCollection === 'ml' ? 'ml' : spaParams?.siteParams?.bactmSiteCollection === 'mlauth' ? 'mlauth' : 'main';
    const notprod = `https://tags.tiqcdn.com/utag/bofa/${profileName}/notprod/utag.sync.js`;
    const prod = `https://tags.tiqcdn.com/utag/bofa/${profileName}/prod/utag.sync.js`;

    // return prod if isProd = true or if isProd is undefined. Safety fallback if isProd isn't defined.
    if (isProd || env.toLowerCase().includes('prod')) {
      return prod;
    } else {
      return notprod;
    }
  } catch (e) {
    // return prod endpoint on failure
    return "https://tags.tiqcdn.com/utag/bofa/main/prod/utag.sync.js";
  }
}
const script = document.createElement('script');
script.src = mboxScript(spaParams.siteParams.isProd, spaParams.siteParams.env);
document.querySelector('head').appendChild(script);
